import React, { useState, useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'
import SecondaryHeader from '../masterLayout/SecondaryHeader'

const AboutUs = () => {
 const [teams, setTeams] = useState([])

 // GET REQUEST FOR TEAM MEMBER
 const getData = async () => {
  try {
   const response = await fetch(
    `${process.env.REACT_APP_API_URL}/teams?status_id=1`,
   )
   const data = await response.json()
   setTeams(data.data)
  } catch (e) {
   console.log(e)
  }
 }

 useEffect(() => {
  getData()
 }, [])

 return (
  <React.Fragment>
   <Helmet>
    <title>
     About Us | Bennabix: Medical Cannabis Discounts & Education
    </title>
    <meta
     name="description"
     content="Bennabix was launched to be the first program to provide medical marijuana users with coverage. Read more, and meet the Bennabix team, here."
    />
   </Helmet>
   <SecondaryHeader page_title="About Us" />
   <div className="sectionWrap">
    <div className="sectionContainer">
     <div className="company_profile">
      <div className="about_intro">
        <h3 className="accent" style={{marginBottom: '0', fontWeight: 'bold'}}>We were born from a simple truth:</h3>
        <h3 className="accent" style={{fontWeight: 'bold'}}>People living with chronic conditions deserve a choice.</h3>
      </div>

      <div className="about_copy">
        <p>
          Bennabix is a healthcare company transforming access to medical cannabis by
          making it a covered benefit through a system that integrates medical
          cannabis into traditional therapeutic healthcare options. We give
          individuals a choice to find relief without the burden of harsh side
          effects and empower employers and providers to offer smarter, more
          holistic benefits.
        </p>
        <p>
          Driven by an experienced team, Bennabix delivers discounts through a
          multistate dispensary network, comprehensive patient education, and a
          roadmap for the medicinal cannabis journey. Our first-to-market system is
          available to individuals as well as employer groups looking to offer a
          unique employee benefit.
        </p>
      </div>

      <div className="about_highlight">
        <p>
          Formerly known as Bennabis Health, our roots lie in advocating for
          compassionate care and access. As Bennabix, we’ve evolved.
        </p>
        <p>
          <strong>
            We’re champions for the power of medical cannabis as a natural
            alternative to traditional pharmaceutical approaches.
          </strong>
        </p>
        <p>
          For far too long, millions have relied on chemical–heavy treatments with
          side effects that can compromise quality of life.
        </p>
        <p>
          Bennabix is here to empower those living with qualifying conditions to
          take control of their health. Through our program, patients save on
          medical cannabis purchases at trusted dispensaries and expert resources,
          removing the barriers of cost and confusion.
        </p>
      </div>

      <div
        className="about_mission"
      >
        <h4>Our mission is clear</h4>
        <p>
          To normalize medical cannabis in healthcare as a respected therapeutic
          choice and to support those ready to explore its potential. We will be
          the first to make medical cannabis a covered employee benefit.
        </p>
      </div>

      <div className="about_statements">
        <h4>
          Because choosing natural relief shouldn’t be the alternative, it should be the standard.
        </h4>
        <h4>
          Bennabix provides the power to choose better health with clarity, control, and confidence in care.
        </h4>

      </div>
    </div>
     <div className="team_wrapper" id="our-team">
      <div className="section_title">
       <h3 style={{ fontFamily: 'Century Gothic, sans-serif', color: '#0A670A' }}>Meet Our Team</h3>
       <p>
        Each of the members of the management team has extensive experience in
        either health insurance or cannabis industry operations.
       </p>
      </div>
      <div className="teamWrap">
       {teams
        .sort((a, b) => a.order_by - b.order_by)
        .map((val) => {
         // let thumbnail = getThumbnail(val.thumbnail);

         return (
          <div className="team" key={val.id}>
           <div className="imgBox">
            <Link to={`/about-us/team/${val.id}`}>
             <img
              src={
               val.thumbnail !== null
                ? val.thumbnail
                : require('../assets/images/avatar.png')
              }
              alt={val.name}
             />
            </Link>
           </div>
           <div className="infoBox">
            <h6> {val.name}</h6>
            <span>{val.designation}</span>
           </div>
          </div>
         )
        })}
      </div>
     </div>
    </div>
   </div>
  </React.Fragment>
 )
}

// function getThumbnail(thumbnail) {
//   let thumb = thumbnail?.includes('http')
//     ? thumbnail
//     : `${process.env.REACT_APP_ADMIN_URL}assets/upload/${thumbnail}`;
//   if (thumbnail === null || thumbnail === undefined || thumbnail === '') {
//     thumb = require('../assets/images/avatar.png');
//   }
//   return thumb;
// }

export default AboutUs
